<div class="dialog-container">
  <h1 mat-dialog-title>{{ 'PLEASE_SELECT_STATION' | translate }}</h1>
  <div mat-dialog-content class="dialog-content">
    <sc-station-search
      (itemSelected)="selectStation($event)"
      styleClass="station-search-simple"
      (clear)="clearSearch()"
      [enter]="false"></sc-station-search>
  </div>
  <div mat-dialog-actions>
    <button
      mat-raised-button
      [disabled]="!station"
      color="primary"
      (click)="dialogRef.close(station)">
      {{ 'LINK_TO_GROUP' | translate }}
    </button>
    <button mat-raised-button (click)="dialogRef.close()">
      {{ 'CANCEL' | translate }}
    </button>
  </div>
</div>
